import styled from 'styled-components';
import { rem } from 'polished';
import Link from '../Link';
var Root = styled.div.withConfig({
  displayName: "ReadMorestyles__Root",
  componentId: "sc-eztlcz-0"
})(["width:", ";"], function (props) {
  return props.wrapperWidth;
});
var Content = styled.div.withConfig({
  displayName: "ReadMorestyles__Content",
  componentId: "sc-eztlcz-1"
})(["&[data-state='closed']{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";overflow:hidden;&& *{margin:0;padding:0;}}"], function (props) {
  return props.lineClamp;
});
var Trigger = styled(Link).withConfig({
  displayName: "ReadMorestyles__Trigger",
  componentId: "sc-eztlcz-2"
})(["font-size:", ";"], function (props) {
  return props.triggerSize === 'small' ? rem('12px') : rem('14px');
});
export var Styled = {
  Content: Content,
  Root: Root,
  Trigger: Trigger
};